import { makeAutoObservable, toJS } from "mobx";
import { apiPostPut, apiGet } from "../api/api_methods";

class CompanyInterviewsStore {
        constructor() {
            makeAutoObservable(this);
        }
        studentInterviews = [];
        setStudentInterviews = (interviews) => {
            this.studentInterviews = interviews;
        }
        getStudentInterviewsData = async () => {
            const user = JSON.parse(localStorage.getItem("user"));
            const response = await apiGet(`/interview/company/${user._id}`);  
            if (response) {
                this.setStudentInterviews(response?.body?.data);
                console.log("thi is response ",response?.body?.data);
                return response?.body?.data;
            }
        }
    
    }
export default CompanyInterviewsStore;